export default __webpack_public_path__ + "static/media/holidays_ic.e1cf4ddf.svg";